import { BaseStore } from 'fluxible/addons';

class OnlineStatusStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.users = {};
    }

    updateStatuses(onlineStatuses) {
        this.users = onlineStatuses;
        this.emitChange();
    }

    getOnlineStatus(id) {
        return this.users[id] ? this.users[id].isOnline : null;
    }

    getLastSeenTime(id) {
        return this.users[id] ? this.users[id].lastSeenTime : null;
    }
}

OnlineStatusStore.storeName = 'OnlineStatusStore';
OnlineStatusStore.handlers = {
    ONLINE_STATUS_SUCCESS: 'updateStatuses',
};

export default OnlineStatusStore;



// WEBPACK FOOTER //
// ./src/js/stores/OnlineStatusStore.js